import React, {useContext} from 'react';
import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import FormControlLabel from "components/radioGroup/FormControlLabel";
import SelectTitle from "components/radioGroup/SelectTitle";
import RadioGroup from "components/radioGroup/RadioGroup";

import {ListContext} from "components/List/context/ListContext";

function ReturnShippingMethodOverride(props) {
    const {values, setFieldValue} = useFormikContext();

    const {notFilteredListItems} = useContext(ListContext);

    function findShippingMethodNameByShopName(shopName) {
        if (shopName) {
            return notFilteredListItems.find(shippingMethod => shippingMethod.shopName === shopName)?.name;
        }

        return '';
    }

    return (
        <>
            <SelectTitle
                titleTranslationKey={'shippingMethods.form.field.printConfig.returnShippingMethodOverride.label'}
                required={true}
            />
            <RadioGroup
                alignListWithButton
                placeholder={props.intl.formatMessage({id: 'shippingMethods.form.field.printConfig.returnShippingMethodOverride.placeholder'})}
                selectedValueLabel={findShippingMethodNameByShopName(values?.printConfig?.returnShippingMethodOverride ?? '')}
                name={'printConfig.returnShippingMethodOverride'}
                value={values.printConfig.returnShippingMethodOverride}
                onClickAway={() => setFieldTouched('printConfig.returnShippingMethodOverride')}
                onChange={(event) => {
                    setFieldValue('printConfig.returnShippingMethodOverride', event.currentTarget.value)
                    setFieldValue('printConfig.printReturnWaybill', true)
                }}
            >
                {notFilteredListItems.map((shippingMethod, index) => (
                    <FormControlLabel
                        key={index}
                        value={shippingMethod.shopName}
                        label={shippingMethod.name}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default injectIntl(ReturnShippingMethodOverride);
